import { ApiError } from "@/api/client";

/**
 * Best-effort human-readable message from a thrown API error (CHP-504).
 *
 * The deal outcome forms used to show a generic "it failed, check the values"
 * on any error, hiding the actual reason (e.g. "First payment date must be in
 * the future."). This surfaces the backend's `detail` — a plain string for our
 * explicit HTTPExceptions, or the FastAPI 422 validation list — and only falls
 * back to `fallback` for opaque / network errors with no usable detail.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const detail = (err.body as { detail?: unknown } | null)?.detail;
    if (typeof detail === "string" && detail.trim() !== "") return detail;
    if (Array.isArray(detail)) {
      const msgs = detail
        .map((d) =>
          d && typeof d === "object" && "msg" in d ? String((d as { msg: unknown }).msg) : "",
        )
        // Pydantic prefixes custom validator messages with "Value error, ".
        .map((m) => m.replace(/^Value error,\s*/, ""))
        .filter((m) => m !== "");
      if (msgs.length > 0) return msgs.join("; ");
    }
  }
  return fallback;
}
